export default __webpack_public_path__ + "static/off-shore-9d16b1106312415b5fc2f06f88af1365.svg";